<template>
  <b-row id="div-header-bar" class="pt-2">
      <b-col cols="12">
          <img src="@/art/logo.png" class="fluid" />
      </b-col>
  </b-row>
</template>

<script>

'use strict'
/* eslint-disable */

var data = {
  debug: false
 };

export default {
  name: "HeaderBar",
  data() {
    return data;
  },
  computed: {
    isLoggedIn() { 
      return this.$root.hasToken() 
    },
    token() {
      return this.$root.getToken()
    }
  },
  methods: {},
  mounted() {}
};
</script>

<style scoped>
#div-header-bar {
    margin: -60px auto 10px auto;
}
</style>


// WEBPACK FOOTER //
// src/components/HeaderBar.vue